<template>
    <div class="container remove-padding-margin">
        <div class="fixed-top bg-white">
            <div class="nav-center pageDefault">
                <div class="row set-row d-flex">
                    <div class="remove-padding navbar-icon-left" @click="back">
                        <img src="../../../assets/gambar/back-blue.svg" alt="">
                    </div>
                    <div class="text-center remove-padding flex-1 font-weight-600">
                        Detail Outlet
                    </div>
                    <div class="navbar-icon-right remove-padding">

                    </div>
                </div>
            </div>
        </div>
        <main>
            <div class="flex-100">
                <div class="flex-1 pad-top-50">
	                <div class="p-l-20 p-r-20 p-d-12 p-t-12 nonActiveOutlet m-d-20 text-left"
	                     v-if="outletnonaktif.sec_active !== 2">
		                <p class="f-14 m-d-4" v-if="outletnonaktif.sec_active === 1 && !outletnonaktif.additionalInfo.expired">
			                Masa trial tersisa <b>{{ outletnonaktif.additionalInfo.remaining_trial_days }} hari</b>. Segera aktivasi outlet ini agar tetap bisa melakukan transaksi.
		                </p>
		                <p class="f-14 m-d-4" v-if="outletnonaktif.sec_active === 0 || outletnonaktif.additionalInfo.expired">
			                Masa trial sudah habis. Segera aktivasi outlet ini agar tetap bisa melakukan transaksi.
		                </p>
		                <p class="f-14 f-c-midgrey m-d-4">
			                Tampilkan outlet terlebih dahulu untuk aktivasi.
		                </p>
	                </div>
                    <div class="d-flex width-100 justify-content-center mar-bottom-16">
                        <div class="animasi-card align-items-center bg-transparent d-flex mar-top-16">
                            <div class="font-16 status-login color-206CF"><span class=""><img class="mar-top-4 mar-bot-4 mar-right-4" style="width: 20px;" src="../../../assets/icons/eye-off.svg" alt=""></span> <span class="font-weight-bold color-206CF">Outlet Disembunyikan</span></div>
                        </div>
                    </div>
                    <div class="">
                        <div class="d-flex width-100 justify-content-center border-bottom">
                            <div v-if="outletnonaktif.logo_url===''" class="upload-file-wrapper">
                                <label for="">
                                    <img src="../../../assets/gambar/Rectangle43.svg" alt=""
                                         style="width: 100px;height: 100px;border-radius: 3px;" v-model="logo_url_nonaktif" id="logo">
                                </label>
<!--                                <input class="input-upload" type='file' id="file" ref="file" v-on:change="handleFileUpload" accept=".png, .jpg, .jpeg"/>-->
                            </div>
                            <div v-else class="upload-file-wrapper">
                                <label for=''>
                                    <figure class="box">
                                        <img class="imgFit" v-bind:src="'https://storage.googleapis.com/bos_revamp/'+ outletnonaktif.logo_url" alt=""
                                             v-if="outletnonaktif.logo_url.includes('bos_revamp/')"
                                             v-model="logo_url_nonaktif" id="logo">
	                                    <img class="imgFit" v-bind:src="'https://storage.googleapis.com/'+ outletnonaktif.logo_url" alt=""
	                                         v-else
	                                         v-model="logo_url_nonaktif" id="logo">
                                    </figure>
                                </label>
<!--                                <input class="input-upload" type='file' id="file" ref="file" v-on:change="handleFileUpload" accept=".png, .jpg, .jpeg"/>-->
                            </div>
                        </div>
                        <div class="">
                            <div class="row remove-margin text-detailO"  data-toggle="modal" data-target="#modalEnamenonaktif">
                                <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
                                    <div class="font-14  mar-top-5 mar-bot-0 color-8080">
                                        Nama Outlet
                                    </div>
                                    <div class="nomore">
                                        {{outletnonaktif.nama}}
                                    </div>
                                </div>
                                <div class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right">

                                </div>
                            </div>
                            <div class="row remove-margin text-detailO"  data-toggle="modal" data-target="#modalEtelpnonaktif">
                                <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
                                    <div class="font-14  mar-top-5 mar-bot-0 color-8080">
                                        Nomor Telpon Outlet
                                    </div>
                                    <div class="nomore">
                                        {{outletnonaktif.telp}}
                                    </div>
                                </div>
                                <div class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right">

                                </div>
                            </div>

                            <div class="row remove-margin text-detailO"  data-toggle="modal" data-target="#modalEtelpnonaktif">
                                <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
                                    <div class="font-14  mar-top-5 mar-bot-0 color-8080">
                                        Kota Outlet
                                    </div>
                                    <div class="nomore">
                                        {{outletnonaktif.kota}}
                                    </div>
                                </div>
                                <div class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right">

                                </div>
                            </div>

                            <div class="row remove-margin text-detailO"  data-toggle="modal" data-target="#modalEtelpnonaktif">
                                <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
                                    <div class="font-14  mar-top-5 mar-bot-0 color-8080">
                                        Alamat Outlet
                                    </div>
                                    <div class="nomore">
                                        {{outletnonaktif.alamat}}
                                    </div>
                                </div>
                                <div class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
        <div class="add-padding-default mar-top-16 boc-div-sticky fixed-bottom background-white">
            <div class="color-33333 font-16 line-height-21 letter-space-002 mar-bottom-24 pad-top-30">Anda tidak dapat mengubah data pada outlet yang disembunyikan</div>
            <div class="button-lanjut ">
                <button class="btn btn-login btn-long remove-margin" id="Btnshowoutlet" @click="aktifoutlet">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                      v-if="isClicked === true"></span><span id="textBtnshowoutlet">Tampilkan Kembali Outlet ini</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "DetailOutletNonaktif",
        props: ["datalistoutlet"],
        data(){
            return{
                outletnonaktif:[],
                logo_url_nonaktif:'',
                idoutlet:'',
                isClicked:false,
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },

            }
        },
        mounted() {
            this.getdetailnonaktif()
        },
        methods:{
            back() {
                this.$emit('golistoutletnonaktif')
            },

            async getdetailnonaktif() {
                if(!this.idoutlet){
                    this.idoutlet=this.parentidoutlet
                }
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/detail_outlet_meta?idoutlet=' + this.datalistoutlet.idoutlet, this.requestHeaders);
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            $('#loadingPage').removeClass('overlayLoading');
                            $('#loadingPage').hide()
                            this.outletnonaktif = response.data.data[0];
	                        this.outletnonaktif.additionalInfo = response.data.aditional_information
                            var res = this.outletnonaktif
                            // this.editnama = res.nama;
                            // this.edittelp = res.telp;
                            // this.editalamat = res.alamat;
                            // this.editkota = res.kota_id;
                            this.idoutlet = res.idoutlet;
                            // this.nomorWaOnkeyup()
                        }
                    }

                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide()
                }
            },

            handleFileUpload() {
                this.logo_url_nonaktif = this.$refs.file.files[0];
                var FileSize = this.$refs.file.files[0].size / 1024 / 1024;
                var validphoto = [".jpg", ".jpeg", ".bmp", ".gif", ".png"];
                if (FileSize > 2) {
                	this.$toast.error('File Gambar tidak boleh lebih dari 2 MB, file anda '+FileSize.toFixed(2)+' MB')
	                $('#file').val("");
	                $('#logo').attr('src', '/img/camera1.75d479aa.svg');
                } else {
                    var blnValid = false;
                    for (var j = 0; j < validphoto.length; j++) {
                        var sCurExtension = validphoto[j];
                        if (this.logo_url_nonaktif.name.substr(this.logo_url_nonaktif.name.length - sCurExtension.length, sCurExtension.length).toLowerCase() == sCurExtension.toLowerCase()) {
                            blnValid = true;
                        }
                    }
                    if (!blnValid) {
                    	this.$toast.error('File photo harus menggunakan format jpg, jpeg, dan png')
                    }else{
                        $('#logo').attr('src', URL.createObjectURL(this.$refs.file.files[0]));
                    }
                }
            },

            async aktifoutlet(){
                this.isClicked = true;
                $('#textBtnshowoutlet').hide()
                $('#Btnshowoutlet').prop('disabled', true);
                try {
                    const aktif = new FormData();
                    aktif.append('idoutlet', this.idoutlet);
                    const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/show_outlet' , aktif,this.requestHeaders);
                    if(response.data.status===true){
                        this.isClicked = false;
                        $('#textBtnshowoutlet').show()
                        $('#Btnshowoutlet').prop('disabled', false);
                        this.back()
	                    this.$toast.success(response.data.msg)
                    }else{
                        this.isClicked = false;
                        $('#textBtnshowoutlet').show()
                        $('#Btnshowoutlet').prop('disabled', false);
                        this.$toast.error(response.data.msg)
                    }

                }catch (e) {
                	this.$catch_error_response(e)
	                this.isClicked = false;
	                $('#textBtnshowoutlet').show()
	                $('#Btnshowoutlet').prop('disabled', false);
                }
            }
        }
    }
</script>

<style scoped>
    .input-upload {
        display: none;
    }

    .box {
        width: 95.53px;
        height: 95.53px;
    }

    .imgFit {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 3px;
        margin-top: 2px;
    }

    .sticky-position{
        position: -webkit-sticky;
        position: sticky;
        top: 0;
        font-size: 20px;
    }

    .boc-div-sticky{
        box-shadow: 0px -6px 12px rgba(0, 0, 0, 0.1);;
    }
</style>